import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  IOutreachTemplate,
  IOutreachTemplateCreate,
  OutreachTemplatesService,
} from '@techspert-io/outreachTemplates';
import { LanguageService } from '../../../../../../../shared/services/language.service';
import { ITemplateForm } from '../../send-solicitation-dialog.component';
import { SolicitationService } from '../../solicitation.service';

@Component({
  selector: 'app-template-form',
  templateUrl: './template-form.component.html',
  styleUrls: ['./template-form.component.scss'],
  standalone: false,
})
export class TemplateFormComponent implements OnInit, OnChanges {
  @Output() selectedItem = new EventEmitter<IOutreachTemplate>();
  @Output() closeFormSignal = new EventEmitter<void>();
  @Output() refreshTemplateMenuSignal = new EventEmitter();
  @Input() inputTemplateFormData: ITemplateForm;
  public template: IOutreachTemplate;
  public formType: string;
  public showActionConfirmOverlay: boolean = false;
  public overlayText: string;

  public languageList = this.languageService.languageCodes;

  get activeTemplate(): IOutreachTemplate {
    return this.solicitationService.activeTemplate;
  }
  constructor(
    private outreachTemplatesService: OutreachTemplatesService,
    protected solicitationService: SolicitationService,
    private languageService: LanguageService
  ) {}

  ngOnInit(): void {
    if (this.formType === 'new') {
      this.template.language = 'en';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.inputTemplateFormData.currentValue !==
      changes.inputTemplateFormData.previousValue
    ) {
      this.template = this.inputTemplateFormData.template;
      this.formType = this.inputTemplateFormData.formType;
    }
  }

  public saveTemplate(): void {
    const newTemplate = this.createTemplate();
    this.outreachTemplatesService.create(newTemplate).subscribe((data) => {
      this.overlayText = 'Saved';
      this.showActionConfirmOverlay = true;
      this.updateSolicitationService(data.templateId);
      setTimeout(() => {
        this.refreshTemplateMenuSignal.emit();
      }, 800);
    });
  }

  public updateTemplate(): void {
    const newTemplate = this.createTemplate();
    this.outreachTemplatesService
      .update({
        ...newTemplate,
        templateId: this.template.templateId,
        versionId: this.template.versionId,
      })
      .subscribe(() => {
        this.overlayText = 'Updated';
        this.showActionConfirmOverlay = true;
        this.updateSolicitationService();
        setTimeout(() => {
          this.refreshTemplateMenuSignal.emit();
        }, 800);
      });
  }

  public deleteTemplate(): void {
    this.outreachTemplatesService
      .delete(this.template.templateId)
      .subscribe(() => {
        this.overlayText = 'Deleted';
        this.showActionConfirmOverlay = true;
        setTimeout(() => {
          this.refreshTemplateMenuSignal.emit();
        }, 800);
      });
  }

  public closeForm(): void {
    this.closeFormSignal.emit();
  }

  private createTemplate(): IOutreachTemplateCreate {
    return {
      title: this.template.title,
      description: this.template.description,
      language: this.template.language,
      subject: this.template.subject,
      content: this.template.content,
      preheader: this.template.preheader,
    };
  }

  private updateSolicitationService(templateId?: string): void {
    this.solicitationService.activeTemplate.content = this.template.content;
    this.solicitationService.activeTemplate.description =
      this.template.description;
    this.solicitationService.activeTemplate.subject = this.template.subject;
    this.solicitationService.activeTemplate.preheader = this.template.preheader;

    this.solicitationService.subject = this.template.subject;
    this.solicitationService.preheader = this.template.preheader;

    if (templateId) {
      this.solicitationService.activeTemplate.templateId = templateId;
    }
  }
}
